





































































/*
    * Method for pupulate date control - STARTS
    1. id - Current field name
    2. field - date field with properties
*/

import Vue from 'vue'; 
import { Component, Prop } from "vue-property-decorator";
import TooltipComponents from "./../../../../../Tooltips/Tooltips.vue";
import moment from 'moment';

/*
    * Component's properties and events
*/
@Component({
     components: { TooltipComponents }
})

export default class DateComponent extends Vue {
    /*
        * Component's props
    */
    @Prop() readonly title!: string;
    @Prop() readonly id!: string;
    @Prop() readonly create!: boolean;
    @Prop() readonly dateOperators!: any;
    @Prop() readonly defaultDateOperators!: any;
    @Prop() readonly disabled!: string;
    @Prop() readonly columns!: string;
    @Prop() readonly displayFormat!: any;
    @Prop() readonly error!: any;
    @Prop() readonly field!: string;
    @Prop() readonly parentName!: string;
    @Prop() readonly inline!: string;
    @Prop() readonly dialog!: boolean;
    @Prop() readonly record!: string;
    @Prop() readonly fieldName!: string;
    @Prop() readonly showInputs!: string;
    @Prop() readonly formCreate!: boolean;
    @Prop() readonly readonly!: string;
    @Prop() readonly reportFilter!: any;
    @Prop() readonly required!: string;
    @Prop() readonly closeOnContentClick!: string;
    @Prop() readonly hint!: string;
    @Prop() readonly browserAutocomplete!: string;
    @Prop() readonly rules!: string;
    @Prop() readonly placeholder!: string;
    @Prop() readonly tooltip!: any;
    @Prop() readonly tooltipList!: any;
    @Prop() readonly edit!: boolean;
    @Prop() readonly weightage!: any;

    /*
        * Component's variables
    */
    private tooltipIcon: boolean = false;
    private tooltipOption: boolean = false;
    private dateId: number = 0;
    private message: string = "";
    translateKey: string = "";


    /*
        *  A component�s data option must be a function, so that each instance can maintain an independent copy of the returned data object.
        *  tooltipIcon - tootip icon show in mouseover
        *  tooltipOption - tootip dialog show in mouseover
    */
    data() {
        return { message: null, translateKey: null, tooltipIcon: false, tooltipOption: false, operators: this.defaultDateOperators };
    }

    //#. define methods under the `methods` object
    _dtChange() {
        let context = this.$store.state[this.parentName];

        //#.Trigger changes
        context.isDirty = true;
    }

    getDate(field, index) {
        let context = this.$store.state[this.parentName], currentDateFormat;
        context.datepicker.closeOnContentClick = false, this.dateId = index;
        currentDateFormat = context.defaultDateFormat;

        if (context.editedItem[this.fieldName] == context.messages.invalidDate) {
            context.editedItem[this.fieldName] = "";
        }

        if (context.editedItem[field.value] == "") {
            // @ts-ignore
            field.date = moment(new Date).format(context.defaultDateFormat);
        }

        if (context.card.type == context.type._grid) {
            field.date = context.editedItem[field.value];
        }

        if (context.editedItem[field.value]) {
            if (!field.displayFormat) {
                field.date = context.editedItem[field.value];
            } else if (field.displayFormat && (field.displayFormat).toLowerCase().indexOf('y') > 0) {
                currentDateFormat = field.displayFormat;
                field.date = context.editedItem[field.value];
            } else {
                let currentSelectedYear = moment(field.date,context.defaultDateFormat).format("YYYY"),
                    selectedDate = moment(context.editedItem[field.value],field.displayFormat).format(context.defaultDateFormat),
                    selectedYear = moment(selectedDate,context.defaultDateFormat).format("YYYY");

                //# Format Issue
                let selectedDateFormatted = moment(selectedDate, context.defaultDateFormat).format('MM/DD/YYYY'),
                    selectedDateReplaced = selectedDateFormatted.replace(selectedYear, currentSelectedYear);

                field.date = moment(selectedDateReplaced,'MM/DD/YYYY').format(context.defaultDateFormat);

                if (context.card.type == context.type._grid) {
                    if(context.editedIndex != -1 && context.data[context.editedIndex][field.value] && !field.selectDate)
                        field.date = moment(context.data[context.editedIndex][field.value],'YYYY-MM-DD').format(context.defaultDateFormat);
                        // @ts-ignore
                    else if(context.editedIndex != -1 && context.data[context.editedIndex][field.value] && field.selectDate && moment(field.selectDate,context.defaultDateFormat).format(field.displayFormat) == this.$refs[this.fieldName].lazyValue)
                        field.date = field.selectDate;
                        // @ts-ignore
                    else if (context.editedIndex != -1 && context.data[context.editedIndex][field.value] && field.selectDate && moment(field.selectDate,context.defaultDateFormat).format(field.displayFormat) != this.$refs[this.fieldName].lazyValue)
                            field.date = moment(context.data[context.editedIndex][field.value],'YYYY-MM-DD').format(context.defaultDateFormat);   
                    else if (context.editedIndex == -1)
                        field.date = field.selectDate;
                }
            }
        }

        if (context.inlineEditor.enabled) {
            field.date = context.formData[context.editedIndex][this.fieldName];
            if(field.displayFormat) {
                currentDateFormat = field.displayFormat;
            }
        }

        if (field.date != undefined && field.date != "") {
            let date = field.date;
            date = moment(date, currentDateFormat).format('MM-DD-YYYY');
            const [month, day, year] = date.split('-');
            context.picker = `${year}-${month}-${day}`;
        } else {
            context.picker = new Date().toISOString().substr(0, 10);
        }
    }

    formatDate(date) {
        if (!date) return null

        let context = this.$store.state[this.parentName];

        const [year, month, day] = date.split('-')
        date = `${month}-${day}-${year}`;
        return moment(date, 'MM-DD-YYYY').format(context.defaultDateFormat);
    }

    handleInput(e) {
        let date = this.formatDate(e),
            context = this.$store.state[this.parentName],
            displayFormat = null;

        //#.Trigger changes
        context.isDirty = true;

        if (this.dialog || (this.dialog == false && context.formGroups && context.formGroups.find(x => x.type == 'Tab'))) {
            displayFormat = context.fields[this.dateId].displayFormat;
            context.fields[this.dateId].date = date;
            context.fields[this.dateId].selectDate = date;
        } else {
            displayFormat = context.fields.filter(x => x.value == this.fieldName).find(x => x).displayFormat;

            if (displayFormat  && displayFormat.toLowerCase().indexOf('y') > 0) {
                context.fields.filter(x => x.value == this.fieldName).find(x => x).date = moment(date,context.defaultDateFormat).format(displayFormat);
            }
            else {
                context.fields.filter(x => x.value == this.fieldName).find(x => x).date = date;
                context.fields.filter(x => x.value == this.fieldName).find(x => x).selectDate = date;
            }
        }

        if (context.landscape == true)
            context.landscape = false;
        else
            context.landscape = true;

        Vue.nextTick(() => {
            //#. Add the component back in
            if (context.landscape == true)
                context.landscape = false;
            else
                context.landscape = true;
        });

        if (context.inlineEditor.enabled) {
            context.formData[context.editedIndex][this.fieldName] = date;
            context.isDirty = true;
        } else {
            context.editedItem[this.fieldName] = date;
        }

        if (displayFormat) {
            if (context.inlineEditor.enabled) {
                context.formData[context.editedIndex][this.fieldName] = moment(date,context.defaultDateFormat).format(displayFormat);   
            } else {
                context.editedItem[this.fieldName] = moment(date,context.defaultDateFormat).format(displayFormat);
            }
        }

        let event = false,
        action = "";

        if(context.inlineEditor.enabled){
            let fieldContext = context.fields.filter(x => x.value == this.fieldName);
            event = fieldContext.find(x => x).event;
            action =  fieldContext.find(x => x).value;
        }

        //#.If checking 'event' annotation is enabled.
        
        if (event) {
            // @ts-ignore
            action = action.charAt(0).toLowerCase() + action.slice(1);

            //#.Change are triggered with the store.dispatch method.
            // @ts-ignore
            this.$store.dispatch(context.fileName + '/' + action + 'Change', e);
        }

        context.datepicker.closeOnContentClick = true;
    }

    handler(field, index) {
        this.getDate(field, index);
    }

    validFormat(date, index) {
        let context = this.$store.state[this.parentName],
            displayFormat = null;

        this.dateId = index;

        if (!this.dialog) {
            displayFormat = context.fields.filter(x => x.value == this.dateId).find(x => x).displayFormat;
            //date = this.$refs[this.fieldName].lazyValue;
        } else {

            if (context.fields[this.dateId])
                displayFormat = context.fields[this.dateId].displayFormat;
            else
                displayFormat = context.fields.filter(x => x.value == this.dateId).find(x => x).displayFormat;
        }

        // @ts-ignore
        if (date && displayFormat && !moment(date, displayFormat, true).isValid()) {
            context.editedItem[this.fieldName] = context.messages.invalidDate;
            // @ts-ignore
        } else if (date && !displayFormat && !moment(date, context.defaultDateFormat, true).isValid()) {
            context.editedItem[this.fieldName] = context.messages.invalidDate;
        } else if (date) {
            displayFormat = (displayFormat == undefined ? context.defaultDateFormat : displayFormat);
            date = moment(date, displayFormat).format(displayFormat)

            if (!context.inlineEditor.enabled)
                context.editedItem[this.fieldName] = date;

            if (!this.dialog)
                // @ts-ignore
                this.$refs[this.fieldName].lazyValue = date;
        }

        if (context.editedItem[this.fieldName] == context.messages.invalidDate) {
            context.dashboard.snackbar = true;
            context.dashboard.color = "error";

            if (!this.dialog)
                // @ts-ignore
                this.$refs[this.fieldName].reset();

            context.editedItem[this.fieldName] = "";
            displayFormat = (displayFormat == undefined ? context.defaultDateFormat : displayFormat);
            context.dashboard.text = context.messages.invalidDateMessage + displayFormat;
            return;
        }

        if (date) {
            let deafultDate: string | null = null;

            if (!this.dialog) {
                deafultDate = context.fields.filter(x => x.value == this.dateId).find(x => x).date;
                displayFormat = context.fields.filter(x => x.value == this.dateId).find(x => x).displayFormat;
            } else {
                deafultDate = context.fields[this.dateId].date;
                displayFormat = context.fields[this.dateId].displayFormat;
            }

            displayFormat = (displayFormat == undefined ? context.defaultDateFormat : displayFormat);
            let pickerDate: string = deafultDate || '',
                currentSelectedYear = moment(pickerDate,displayFormat).format("YYYY"),
                selectedDate = moment(date,displayFormat).format(context.defaultDateFormat),
                selectedYear = moment(selectedDate,context.defaultDateFormat).format("YYYY");

            if (selectedYear == context.messages.invalidDate) {
                // @ts-ignore
                context.fields[this.dateId].date = moment(new Date).format(context.defaultDateFormat);
                return;
            }

            deafultDate = selectedDate.replace(selectedYear, currentSelectedYear);
        }
    }

    /*
        * Method for show tooltip
    */
    _tpShowTooltip() {
        if (!this.tooltip) {
            return;
        }

        this.tooltipOption = true;
    }

    /*
        * Method for remove tooltip
    */
    _tpRemoveTooltip() {
        if (!this.tooltip) {
            return;
        }

        this.tooltipOption = false;
        this.tooltipIcon = false;
    } 

    /*
        * Method for show error
    */
    _tpError(error) {
        this.$store.state.notify.enabled = true;
        this.$store.state.notify.text = error;
        this.$store.state.notify.color = 'error';
    }

    /*
        * Method for remove error
    */
    _tpRemoveError(error) {
        this.$store.state.notify.enabled = false;
    }

    /*
        * Method for operator dropdown change event
    */
    _opChange(val) {
        // @ts-ignore
        this.operators == this.dateOperators.filter(x => x.value == val).find(x => x);

        // @ts-ignore
        this.$store.state[this.parentName].fields.filter(x => x.value == this.fieldName).find(x => x).filterOperator = this.operators;
    }

    /*
        *  Key translator
    */
    get translator(): string {
        let context = this.$store.state[this.parentName];
        this.message = context.messages.dateSelection;

        if (context && !context.keyTranslator) {
            this.translateKey = this.title;
            return this.translateKey;
        }
        
        this.translateKey = (this.$t(this.title) || this.title).toString();
        return this.translateKey;
    }

    /*
        *  Default operators
    */
    get operator(): any {
        // @ts-ignore
        this.field.filterOperator = this.defaultDateOperators.key;
        return;
    }
}
